import type { ReactNode } from "react";

/** Responsive templates own layout; screens only choose a composition. */
export function Workspace({ children, variant = "overview" }: { children: ReactNode; variant?: "overview" | "calendar" | "record" | "pricing" | "form" | "report" | "booking" }) {
  return <div className={`v365-workspace v365-workspace-${variant}`}>{children}</div>;
}

export function Region({ children, area, label }: { children: ReactNode; area: "main" | "aside" | "header" | "actions"; label?: string }) {
  return <section className={`v365-region v365-region-${area}`} aria-label={label}>{children}</section>;
}

export function FormGrid({ children }: { children: ReactNode }) {
  return <div className="v365-form-grid">{children}</div>;
}

export function Toolbar({ children }: { children: ReactNode }) {
  return <div className="v365-toolbar">{children}</div>;
}

export function FormSection({ title, children, variant = "default" }: { title: string; children: ReactNode; variant?: "default" | "schedule" }) {
  return <section className={`v365-form-section${variant === "schedule" ? " v365-form-section-schedule" : ""}`}><h2>{title}</h2><div className="v365-form-section-body">{children}</div></section>;
}

export function SaveBar({ children }: { children: ReactNode }) {
  return <div className="v365-save-bar">{children}</div>;
}

export function CollectionHeader({ columns }: { columns: string[] }) {
  return <div className="v365-collection-header" aria-hidden="true">{columns.map((c) => <span key={c}>{c}</span>)}</div>;
}

export function ConversationLayout({ list, children, selected }: { list: ReactNode; children: ReactNode; selected: boolean }) {
  return <main className={`v365-conversations ${selected ? "v365-conversations-selected" : ""}`}>
    <section className="v365-conversation-list" aria-label="Conversations">{list}</section>
    <section className="v365-conversation-detail" aria-label="Conversation">{children}</section>
  </main>;
}
